import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type { FilterCategories, FilterCategory } from "../types/category";

export const normalizeCategories = (category: FilterCategories): readonly FilterCategory[] =>
    is.string(category) ? [category] : category;
